export * from './language';
export * from './error';
export * from './paths';
export * from './request-data';

export const
  HTTP_HEADER_CONTENT_TYPE = 'Content-Type',
  HTTP_HEADER_AUTHORIZATION = 'Authorization',
  HTTP_HEADER_CORS= 'Access-Control-Allow-Origin',
  HTTP_HEADER_MODULE_CODE = 'Module-Code',
  HTTP_HEADER_TOKEN = 'Token',
  MIME_TYPE_JSON = 'application/json',

  FILTER_DEFAULT_START_TIME = "00:00:00",
  FILTER_DEFAULT_END_TIME = "23:59:00",

	DATETIME_FORMAT_FILE_PREFIX_S3 = "YYYYMMDDHHmmssSSS",
  DATETIME_FORMAT_REQUEST = "YYYY-MM-DD HH:mm:ss",
  DATE_FORMAT_VIEW = "MM/DD/YYYY",
  DATETIME_FORMAT_VIEW = "MM/DD/YYYY hh:mm A",

  PATTERN_LETTERS= '^[a-zA-Z]*$',
  PATTERN_LETTERS_WITH_SPACE = '^[a-zA-Z ]*$',
  PATTERN_LETTERS_WITH_SPACE_HYPHEN = '^[a-zA-Z- ]*$',
  PATTERN_LETTERS_WITH_SPACE_PERIOD = '^[a-zA-Z. ]*$',
  PATTERN_ALPHA_NUMERIC_SPACE_ONLY = '.*\\S.*[a-zA-z0-9 ]',
  PATTERN_ALPHA_NUMERIC_NO_SPACE = '^\\s*[a-zA-Z0-9]*\\s*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE = '^[a-zA-Z0-9 ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR = '^[a-zA-Z0-9-_. ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_CHAR = '^[a-zA-Z0-9-_.]*$',
  PATTERN_NUMERIC = '^-*[0-9]*$',
  PATTERN_NUMERIC_WITH_SIGN = '^-*[0-9]+$',
  PATTERN_NUMERIC_WITH_SPACE = '^[0-9 _ ,+]*$',
  PATTERN_DECIMAL = /^-?[0-9]+(\.[0-9]{0,2})?$/,
  PATTERN_DECIMAL_WITH_SIGN = '^-*[0-9]*(\.[0-9]{0,2})?$',
  PATTERN_NUMERIC_NEGATIVE = '^-[0-9]*$',
  // standard email pattern before bbb-539
  // PATTERN_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  PATTERN_EMAIL = '^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  PATTERN_NO_SPACE = '^([^ ])*$',
  PATTERN_WEEK = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{4})$',
  PATTERN_WEEK_NUMBER = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{1,})$',
  PATTERN_WEEK_FORMAT = '^(.{1,2})-(.{4})$',
  PATTERN_V5_CUSTOMER_CODE = '^[V]([0-9]{9})',
  PATTERN_RESTRICTED_FILENAME_CHARS = '^[^/\\\\:\*"<>|]*$',
  PATTERN_DATE = '/(([0-2]?\d{1})|([3][0,1]{1}))/^[0,1]?\d{1}/(([1]{1}[9]{1}[9]{1}\d{1})|([2-9]{1}\d{3}))$/',
  PATTERN_OTHER_ADDRESS = '^[a-zA-Z-,. ]*$',
  PATTERN_ZIP = '^[a-zA-Z0-9-]*$',
  PATTERN_CONTACT_NUMBERS = '^[0-9- ()+,]*$'
;